import React from 'react';
import { general } from '~/assets/imgs';
import Button from '~/components/Button';
import AuthWebLayout from '~/screens/Auth/layout/AuthLayout/AuthWebLayout';
import { LanguageProps } from '~/screens/Auth/layout/AuthLayout/types';
import { t } from '~/utils/i18n';
import { MainImage, Title, Desc } from './style';

type NotFoundLayoutProps = LanguageProps & { goToMainPage: () => void } & {
  openContactSupport: () => void;
};

export default function NotFound({
  selectedLocale,
  onSelectedLocale,
  goToMainPage,
  openContactSupport,
}: NotFoundLayoutProps): JSX.Element {
  return (
    <AuthWebLayout languageProps={{ selectedLocale, onSelectedLocale }}>
      <>
        <MainImage source={general.flame} resizeMode={'contain'}></MainImage>
        <Title>{t('notFound.title')}</Title>
        <Desc>{t('notFound.desc')}</Desc>
        <Button
          type={'secondary-base'}
          text={t('notFound.contactSupport')}
          onPress={openContactSupport}
          bottomMargin={10}
          flex={true}
        ></Button>
        <Button
          type={'secondary-contrast'}
          text={t('notFound.backToMain')}
          onPress={goToMainPage}
          flex={true}
        ></Button>
      </>
    </AuthWebLayout>
  );
}
